import { useEffect, useState } from "react"
import useAxiosInstance from "../../../../../Utilities/Hooks/useAxiosInstance"
import Form from "../../../../Partials/Layouts/Forms/Form"
import FormSubmitButton from "../../../../Partials/Layouts/Forms/FormSubmitButton/FormSubmitButton"
import { PRODUCTS_API, MATERIAL_API, PRODUCTMATERIAL_API } from "../../../../../Utilities/APIs/APIs"
import SelectInput from "../../../../Partials/Layouts/Forms/FormInputs/SelectInput/SelectInput"
import SelectOption from "../../../../Partials/Layouts/Forms/FormInputs/SelectInput/SelectOption/SelectOption"

function UpdateProductMaterial({productID, targetID, triggerFetch, setShowUpdateForm }) {

    const axiosInstance = useAxiosInstance()

    const [product, setProduct] = useState('')
    const [material, setMaterial] = useState('')

    const [materials, setMaterials] = useState(null)

    useEffect(() => {
        async function fetchAndSetSingleProductMaterial() {
            const { data } = await axiosInstance.get(PRODUCTMATERIAL_API + 'getSingleProductMaterial/' + targetID)
            setProduct(data.product._id)
            setMaterial(data.material._id)
        }
        fetchAndSetSingleProductMaterial()

    }, [targetID, axiosInstance])

    useEffect(() => {
        async function fetchAndSetMaterials() {
            const { data } = await axiosInstance.get(MATERIAL_API)
            setMaterials(data)
        }
        fetchAndSetMaterials()

    }, [axiosInstance])

    async function handleSubmit(e) {

        e.preventDefault()
        const itemData = new FormData()

        itemData.append('product', productID)
        itemData.append('material', material)

        const response = await axiosInstance.patch(PRODUCTMATERIAL_API + targetID, itemData)
        if (response) {
            triggerFetch()
            setShowUpdateForm(false)
        }
    }

    return (
        <div className='crate_form'>
            <Form onSubmit={handleSubmit}>
                <div>
                    <SelectInput
                        label={'Material'}
                        value={material}
                        setState={setMaterial}
                    >
                        <SelectOption optionValue='' optionText="Select Material" />
                        {materials?.map((material => (
                            <SelectOption optionValue={material._id} key={material._id}
                                optionText={material?.name} />
                        )))}
                    </SelectInput>
                </div>
                <FormSubmitButton text="Update Product Material" />
            </Form>
        </div>
    )
}

export default UpdateProductMaterial